<div class="project">
	<div class="project-bar">
		<div class="project-percent" [attr.percent]="progress + '%'" [ngStyle]="{ width: progress + '%' }"></div>
	</div>
</div>
